module.exports = __webpack_public_path__ + "static/media/vfl-mobileWithLogo.4d9df168.png";